import { useRouter } from 'next/router'

export const useNetworkName = () => {
  const { query } = useRouter()

  return query.network as string
}
